import { Amplify } from 'aws-amplify'
import { config } from '@/config'

let configured = false

export function isCognitoConfigured(): boolean {
  return Boolean(config.cognito.userPoolId && config.cognito.clientId)
}

/** Configure Amplify Auth for embedded email/password flows. */
export function configureAmplify(): void {
  if (configured || !isCognitoConfigured()) {
    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.cognito.userPoolId,
        userPoolClientId: config.cognito.clientId,
      },
    },
  })

  configured = true
}
